function createElement(params) {
    if(!params.name)
        return null;

    var node = document.createElement(params.name);
    if(x = params.id)           node.id = x;
    if(x = params.classes)      node.className = x;
    if(x = params.href)         node.href = x;
    if(x = params.innerText)    node.innerText = x;
    if(x = params.innerHTML)    node.innerHTML = x;

    if(x = params.parent)       x.appendChild(node);
    if(x = params.childs) {
        if(typeof x.forEach !== 'function')  x = [].slice.call(x);
        x.forEach(function(child) {
            node.appendChild(child);
        });
    }
    
    return node;
}